import React from 'react';

const RestTimer = ({ resting, restTime, skipRest, t }) => {
  if (!resting) return null;

  return (
    <div>
      <div style={{ color: '#b85b7b' }}>{t('rest_time', { time: restTime })}</div>
      <button
        className="pretty-btn"
        onClick={skipRest}
        style={{
          marginTop: 12,
          background: 'linear-gradient(90deg, #f7a8c7 0%, #f8bfcf 100%)',
          color: '#fff',
        }}
      >
        {t('skip_rest')}
      </button>
    </div>
  );
};

export default RestTimer;
